var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"heading"}},[_c('div',{staticClass:"p-4 md:p-6 font-bold uppercase"},[_vm._v(" "+_vm._s(_vm.getTranslation(_vm.course.title))+" ")]),_c('div',{staticClass:"progress-bar-wrapper"},[_c('ui-progress-bar',{attrs:{"percentage":_vm.computeCompleted}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }